import { mergeStyles } from "@fluentui/merge-styles";
import { BORDER_COLOR } from "../../../../config/colors";

export const wrapperClasses = mergeStyles({
  color: "#797774",
  border: `1px solid ${BORDER_COLOR}`,
  padding: "5px 15px",

  "&:hover": {
    boxShadow: "2px 1px 4px rgba(0,0,0, 0.3)",
  },
});

export const titleClasses = mergeStyles({
  marginBottom: 5,
});

export const itemTitleClasses = mergeStyles({
  color: "#000",
  marginBottom: 5,
  textDecoration: "none",

  "&:hover": {
    color: "#2A5699",
  },
});

export const itemClasses = mergeStyles({
  display: "flex",
});
export const itemBodyClasses = mergeStyles({});
export const itemAsideClasses = mergeStyles({
  width: 20,
  flexShrink: 0,
});

export const stackColumnGap10 = mergeStyles({
  display: "flex",
  flexDirection: "column",
  gap: 10,
});
